/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedPagination_buyPage$ref = any;
export type BuySharedPagination_buyPage = {
    readonly maxNumberOfPages: number | null;
    readonly " $refType": BuySharedPagination_buyPage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "BuySharedPagination_buyPage",
    "type": "BuyPageConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxNumberOfPages",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'f2bb646cfacc58ad7534068afe04e1fc';
export default node;
